/** The URL query param key to show the enquiry modal on page load. */
export const ENQUIRE_MODAL_SHOWUP_KEY = 'enquire';
export const ENQUIRE_MODAL_SHOWUP_KEY_VALUE = '1';
export const ENQUIRE_AUTH_SOURCE_VALUE = 'enquiry';
